import * as React from 'react';
import { Box, Flex, flameTheme } from '@lightspeed/flame/Core';
import { Button } from '@lightspeed/flame/Button';
import { Bone } from '@lightspeed/flame/Bone';
import { TextLink } from '@lightspeed/flame/Text';
import { useDispatch } from 'react-redux';
import { IconDownload } from '@lightspeed/flame/Icon/Download';
import { PROTOCOL_IFRAME } from 'pages/views/devices/utils/helper';

interface DownloadAppElementProps {
  url?: string;
  isButton?: boolean;
  content?: string | React.ReactNode;
  hasIcon?: boolean;
  [prop: string]: any;
}

const DownloadAppElement: React.FC<DownloadAppElementProps> = ({
  url,
  isButton,
  content,
  hasIcon,
  ...rest
}) => {
  const { lineHeights } = flameTheme;
  const dispatch = useDispatch();
  if (!url)
    return (
      <Box {...rest}>
        <Bone width="100px" height="21px" />
      </Box>
    );

  return isButton ? (
    <Button
      fill
      variant="secondary"
      // override the cirrus <a> tag style while cirrus exists
      style={{ color: 'white' }}
      noSpacing
      href={url}
      target={PROTOCOL_IFRAME}
      download
      {...rest}
      onClick={() =>
        dispatch({
          type: 'HUB_UPDATE_DOWNLOAD_STATUS',
          payload: { hasStartedHubDownload: true },
        })
      }
    >
      {hasIcon ? (
        <Box mr={2}>
          <IconDownload size="small" />
        </Box>
      ) : null}
      {content || 'Download Hub'}
    </Button>
  ) : (
    <Flex flexDirection="column" justifyContent="center" alignItems="flex-start" {...rest}>
      <Box pr={1}>
        <TextLink
          href={url}
          target={PROTOCOL_IFRAME}
          download
          onClick={() =>
            dispatch({
              type: 'HUB_UPDATE_DOWNLOAD_STATUS',
              payload: { hasStartedHubDownload: true },
            })
          }
          lineHeight={lineHeights[4]}
        >
          {content || 'Download it here.'}
        </TextLink>
      </Box>
    </Flex>
  );
};

export { DownloadAppElement };
